import { render, staticRenderFns } from "./PageMercuriales.vue?vue&type=template&id=388de0a0&"
import script from "./PageMercuriales.vue?vue&type=script&lang=js&"
export * from "./PageMercuriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388de0a0')) {
      api.createRecord('388de0a0', component.options)
    } else {
      api.reload('388de0a0', component.options)
    }
    module.hot.accept("./PageMercuriales.vue?vue&type=template&id=388de0a0&", function () {
      api.rerender('388de0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Mercuriales/PageMercuriales.vue"
export default component.exports